import * as i18n from 'i18next';
import { keyBy } from "lodash";
import { Asset, AssetType, Container, LogoAssetProperties } from "shared/models";
import { makeNewAsset } from "ui/editor/makeNewAsset";
import { makeNewContainer } from 'ui/editor/makeNewContainer';

const margin = .025;
const minTextHeight = 0;

// These fields are for DMG. They put these fields directly on the screen.
// They indicated that the values would come from their ERP system.
export function makeDmgContainers(width: number, height: number, isNorthAmerica: boolean, t: i18n.TFunction) {
    const dmgPIAssets: Asset[] = [];
    const dmgPIDetailsContainers: Container[] = [];
    const dmgPIFreeTextContainers: Container[] = [];
    
    if (isNorthAmerica) {
        return {
            dmgContainers: [],
            dmgAssets: {},
        };
    }

    const ceLogoAsset = makeNewAsset(AssetType.Logo, width, height, undefined, undefined, minTextHeight);
    (ceLogoAsset.properties as LogoAssetProperties).logo = 'ce';
    (ceLogoAsset.properties as LogoAssetProperties).color = '#fff';
    const ceLogoContainer = makeNewContainer({
        top: 1 - margin - .09,
        left: margin,
        width: .1,
        height: .08,
        displayName: t('THEME_EDITOR.PI.LOGO.CE'),
        type: 'logo',
        assetOrder: [ ceLogoAsset.id ],
        visible: true,
    });

    const ceNumberAsset = makeNewAsset(AssetType.CeNumber, width, height);
    const ceNumberContainer = makeNewContainer({
        top: 1 - margin - .1,
        left: margin + .1,
        width: .15,
        height: .1,
        displayName: t('THEME_EDITOR.PI.CE_NUMBER'),
        type: 'dmg',
        assetOrder: [ ceNumberAsset.id ],
        visible: true,
    });

    for (let i = 1; i <= 4; i++) {
        const freeTextAsset = makeNewAsset(`freeText${i}` as AssetType, .33, .08, undefined, undefined, minTextHeight);
        dmgPIAssets.push(freeTextAsset);
        dmgPIFreeTextContainers.push(
            makeNewContainer({
                top: .5 + (i - 1) * .09,
                left: margin,
                width: .33,
                height: .08,
                displayName: t('THEME_EDITOR.PI.FREE_TEXT_N', [ i ]),
                type: 'dmg',
                assetOrder: [ freeTextAsset.id ],
                visible: true,
            })
        );

        const detailsAsset = makeNewAsset(`details${i}` as AssetType, .33, .08, undefined, undefined, minTextHeight);
        dmgPIAssets.push(detailsAsset);
        dmgPIDetailsContainers.push(
            makeNewContainer({
                top: .5 + (i - 1) * .09,
                left: .5,
                width: .33,
                height: .08,
                displayName: t('THEME_EDITOR.PI.INSTALL_DETAILS_N', [ i ]),
                type: 'dmg',
                assetOrder: [ detailsAsset.id ],
                visible: true,
            })
        );
    }

    return {
        dmgContainers: [
            ...dmgPIFreeTextContainers.reverse(),
            ...dmgPIDetailsContainers.reverse(),
            ceLogoContainer,
            ceNumberContainer,
        ],
        dmgAssets: keyBy([
            ...dmgPIAssets,
            ceLogoAsset,
            ceNumberAsset,
        ], 'id'),
    };
}